var app = angular.module("leonardo");

var DocumentListExpired = function($scope, $window, $filter, $state, FolderFileService, FolderRequirementsService,
                                   ngDialog, FilterService, AuthDataService, TaskService, $controller, $q,
                                   AttachmentService, NotificationService, AnalyticsService) {

  $scope.files = [];
  $scope.files_noticed = [];
  $scope.files_missing = [];
  $scope.tableFilterSize = 20;

  $scope.folderFileService = FolderFileService;
  $scope.attachmentService = AttachmentService;

  $scope.downloadFile = function(url, fileName) {
    var xhr = new XMLHttpRequest();
    var imageUrl = '';
    xhr.open("GET", url, true);
    xhr.responseType = "blob";
    xhr.onload = function(){
      var urlCreator = window.URL || window.webkitURL;
      if (AttachmentService.getClassesAttachment({name: url}) === 'image') {
        imageUrl = urlCreator.createObjectURL(this.response);
      }
      else {
        imageUrl = url;
      }
      var tag = document.createElement('a');
      tag.href = imageUrl;
      tag.download = fileName;
      document.body.appendChild(tag);
      tag.click();
      document.body.removeChild(tag);
    };
    xhr.onreadystatechange = function (oEvent) {
      if (xhr.readyState === 4) {
        if (xhr.status !== 200) {
          NotificationService.error('File not found');
        }
      }
    };
    xhr.send();
  };

  $scope.showFile = function(file){
    AnalyticsService.track('Document Opened', {
      ...AnalyticsService.getDocumentGroupProperties(file),
      context: 'Document Manager'
    });
    if (file.document_file) {
      // Use signed_view_url for secure inline viewing, fallback to secure_share_url
      $window.open(file.document_file.signed_view_url || file.document_file.secure_share_url, '_blank');
    }
    else if (file.link) {
      $window.open(file.link, '_blank');
    }
    else {
      // Use signed_view_url for secure inline viewing, fallback to secure_share_url
      $window.open(file.signed_view_url || file.secure_share_url, '_blank');
    }
  };

  $scope.getParams = function () {
    return { expired: true, status: 0 };
  };

  $scope.getParamsMissing = function () {
    return { missing: true };
  };

  $scope.getParamsNoticed = function () {
    return { noticed: true, status: 0 };
  };

  $scope.getEntitiesPromise = function(options) {
    var defer = $q.defer();
    if (FilterService.getFilter('group_reports')) {
      options['group'] = FilterService.getFilter('group_reports');
    }
    if (FilterService.getFilter('portfolio_reports')) {
      options['portfolio'] = FilterService.getFilter('portfolio_reports');
    }
    if (FilterService.getFilter('property_reports')){
      options['property'] = FilterService.getFilter('property_reports');
    }

    var params = $scope.getParams();
    var paramsNoticed = $scope.getParamsNoticed();
    var paramsMissing = $scope.getParamsMissing();
    angular.forEach(options, function(value, key) {
      params[key] = value;
      paramsNoticed[key] = value;
      paramsMissing[key] = value;
    });
    params['archive'] = false;
    params['valid_portfolio_property']  = true;
    paramsNoticed['archive'] = false;
    paramsNoticed['valid_portfolio_property']  = true;
    var promises = [];
    $scope.files = [];
    $scope.files_noticed = [];
    $scope.files_missing = [];
    $scope.datas = {};
    $scope.loading = true;
    var defer_files = $q.defer();
    promises.push(defer_files.promise);
    FolderFileService.getlist(params, true).then(function(data) {
      $scope.files = data.results ? data.results : data;
      $scope.datas['expired'] = data;
      defer_files.resolve();
    }, function (error) {
      if (error.data && angular.isString(error.data.detail) && error.data.detail.startsWith('Invalid page')) {
        $scope.files = [];
        $scope.datas['expired'] = {};
      }
      defer_files.resolve();
    });
    var defer_noticed = $q.defer();
    promises.push(defer_noticed.promise);
    FolderFileService.getlist(paramsNoticed, true).then(function(data) {
      $scope.files_noticed = data.results ? data.results : data;
      $scope.datas['noticed'] = data;
      defer_noticed.resolve();
    }, function (error) {
      if (error.data && angular.isString(error.data.detail) && error.data.detail.startsWith('Invalid page')) {
        $scope.files_noticed = [];
        $scope.datas['noticed'] = {};
      }
      defer_noticed.resolve();
    });
    var defer_missing = $q.defer();
    promises.push(defer_missing.promise);
    FolderRequirementsService.getlist(paramsMissing, true).then(function(data) {
      $scope.files_missing = data.results ? data.results : data;
      $scope.datas['missing'] = data;
      defer_missing.resolve();
    }, function (error) {
      if (error.data && angular.isString(error.data.detail) && error.data.detail.startsWith('Invalid page')) {
        $scope.files_missing = [];
        $scope.datas['missing'] = {};
      }
      defer_missing.resolve();
    });

    $q.all(promises).then(function () {
      $scope.files = $scope.files.concat($scope.files_noticed);
      if (($scope.files.length === 0) && ($scope.files_missing.length === 0)) {
        ngDialog.open({ template: 'views/templates/dialog/no-results.html'});
      }
      defer.resolve($scope.updateData());
    }).finally(function() {
      $scope.loading = false;
    });;

    return defer.promise;
  };

  $scope.getSector = function() {
    if ((AuthDataService.isAdmin() || AuthDataService.isWhiteLabelAdmin())) {
      return FilterService.hasFilter('sector') ? FilterService.getFilter('sector') : null;
    }
    return null;
  };

  $scope.onEditFile = function(file) {
    ngDialog.open({
      template: 'views/templates/dialog/folder-file/upload.html',
      controller: 'FolderFileAdd',
      resolve: {
        folder: ['FolderService', function (FolderService) {
          var defer = $q.defer();
          if (file.folder) {
            defer = FolderService.get(file.folder);
          }
          else {
            defer.resolve(null);
          }
          return defer.promise;
        }]
      },
      data: {
        entity: file,
        action: 'edit'
      }
    });
  };

  $scope.onResolveFile = function(file) {
    if (file.action_item) {
      TaskService.get(file.action_item).then(function(task) {
        ngDialog.openConfirm({
          template: 'views/templates/dialog/folder-file/resolve-document-file.html',
          controller: 'TaskResolveDocumentFileDialog',
          resolve: {
            folder: ['FolderService', function (FolderService) {
              return null;
            }]
          },
          data: {
            entity: null,
            task: task,
            name: file.name
          }
        }).then(function(){
          $scope.loadPage($scope.page);
        });
      });
    }
  };

  $scope.onDeleteFile = function(file) {
    ngDialog.openConfirm({
      template: 'views/templates/dialog/delete.html',
      controller: 'DeleteDialog',
      data: {
        object: file,
        type: 'file'
      }
    }).then(function(){
      $scope.loadPage($scope.page);
    });
  };

  $scope.onMoveFile = function(file) {
    ngDialog.openConfirm({
      template: 'views/templates/dialog/folder/selector.html',
      controller: 'FolderSelectorDialog',
      data: {
        excludeFolder: file.parent,
        rootDisabled: true,
        sector: $scope.getSector()
      }
    }).then(function(data) {
      var destiny = data ? data.destiny.id : data;
      if (data.action === 'move') {
        file.patch({folder: destiny}).then(function() {
          $scope.loadPage($scope.page);
        });
      }
      else {
        file.copyTo({to_folder: destiny}).then(function() {
          $scope.loadPage($scope.page);
        });
      }
    });
  };

  $scope.showSharePopup = function(file){
    ngDialog.open({
      template: 'views/templates/dialog/folder-file/share-file.html',
      controller: 'FolderFileShareDialog',
      data: {
        file: file
      }
    });
  };

  $scope.showDismissPopup = function(file) {
    if (file.action_item){
      TaskService.get(file.action_item).then(function(task) {
        ngDialog.openConfirm({
          template: 'views/templates/dialog/task/dismiss.html',
          controller: 'TaskDismissDialog',
          data: {
            task: task,
            file: file
          }
        }).then(function(){
          $scope.loadPage($scope.page);
        });
      });
    }
    else {
      ngDialog.openConfirm({
        template: 'views/templates/dialog/task/dismiss.html',
        controller: 'TaskDismissDialog',
        data: {
          file: file
        }
      }).then(function(){
        $scope.loadPage($scope.page);
      });
    }
  };

  $scope.isExpired = function(file) {
    if (!file.archive && file.show_warning) {
      var today = moment(new Date());
      if (file.expiration && (moment(new Date(file.expiration)).format('YYYY-MM-DD') <= today.format('YYYY-MM-DD'))){
        return true;
      }
    }
    return false;
  };

  $scope.isNoticed = function(file) {
    if (!file.archive && file.show_warning) {
      var today = moment(new Date());
      if (file.notice && (moment(new Date(file.notice)).format('YYYY-MM-DD') <= today.format('YYYY-MM-DD'))){
        return true;
      }
    }
    return false;
  };

  $scope.showFileAddDialog = function(requirement) {
    ngDialog.open({
      template: 'views/templates/dialog/folder-file/upload.html',
      controller: 'FolderFileAdd',
      resolve: {
        folder: [function () {
          if (requirement.document_folder) {
            return requirement.document_folder;
          }
          return null;
        }]
      },
      data: {
        entity: null,
        action: 'create',
        status: 'missing',
        requirement: requirement
      }
    });
  };

  $scope.gotoRequeriment = function (file) {
    $state.go('documents.list', {pk: file.document_folder.id});
  };

  $scope.$on('folder-file:created', function() {
    $scope.loadPage($scope.page);
  });
  $scope.$on('folder-file:updated', function() {
    $scope.loadPage($scope.page);
  });
  $scope.$on('task-resolve-dialog:success', function() {
    $scope.loadPage($scope.page);
  });

  $controller('TableFilterController', { $scope: $scope });

  $scope.loadPage($scope.page);
};

app.controller('DocumentListExpired', ['$scope', '$window', '$filter', '$state', 'FolderFileService',
  'FolderRequirementsService', 'ngDialog', 'FilterService', 'AuthDataService', 'TaskService', '$controller', '$q',
  'AttachmentService', 'NotificationService', 'AnalyticsService', DocumentListExpired]);
